(function () {
  if (window.ErBuddhaLifeRevealLoaded) return;
  window.ErBuddhaLifeRevealLoaded = true;

  var rootSelector = '[data-er-buddha-life]';
  var cardSelector = '[data-er-toggle-image]';
  var openClass = 'is-open';

  function loadImage(card) {
    var image = card.querySelector('[data-er-lazy-image]');

    if (!image || image.dataset.loaded) return;

    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;

    image.dataset.loaded = '1';
  }

  function setCard(card, open) {
    var drop = card.querySelector('.er-stage-drop');

    card.classList.toggle(openClass, open);
    card.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (drop) {
      drop.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    if (open) loadImage(card);
  }

  function setupSection(section) {
    if (!section || section.dataset.erRevealReady) return;

    section.dataset.erRevealReady = '1';

    section.addEventListener('click', function (event) {
      var card = event.target.closest(cardSelector);

      if (!card || !section.contains(card)) return;

      event.preventDefault();

      var shouldOpen = !card.classList.contains(openClass);

      section.querySelectorAll(cardSelector + '.' + openClass).forEach(function (openCard) {
        setCard(openCard, false);
      });

      setCard(card, shouldOpen);
    });
  }

  function init(scope) {
    scope = scope || document;

    if (scope.matches && scope.matches(rootSelector)) {
      setupSection(scope);
      return;
    }

    scope.querySelectorAll(rootSelector).forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();